import { createContext, useContext, useEffect, useState } from 'react';
import { statisticsRange, formatStatisticsInput } from '../utils/frameStatisticsDate';

const DateFilterContext = createContext(null);

export const DateFilterProvider = ({ children }) => {
    const { start, end } = statisticsRange();
    const defaultFrom = formatStatisticsInput(start);
    const defaultTo = formatStatisticsInput(end);
    const [from, setFrom] = useState(() => localStorage.getItem('date_filter_from') || defaultFrom);
    const [to, setTo] = useState(() => localStorage.getItem('date_filter_to') || defaultTo);

    useEffect(() => {
        localStorage.setItem('date_filter_from', from);
    }, [from]);

    useEffect(() => {
        localStorage.setItem('date_filter_to', to);
    }, [to]);

    const value = { from, to, setFrom, setTo };

    return (
        <DateFilterContext.Provider value={value}>
            {children}
        </DateFilterContext.Provider>
    );
};

export const useDateFilter = () => {
    const context = useContext(DateFilterContext);
    if (!context) {
        throw new Error('useDateFilter must be used within a DateFilterProvider');
    }
    return context;
};
